import React from 'react';
import Banner from './components/Banner';
import Benefits from './components/Benefits';
import DataReceive from './components/DataReceive';
import Footer from './components/Footer';
import Header from './components/Header';
import Help from './components/Help';
import Operation from './components/Operation';
import Partnership from './components/Partnership';
import WhatsAppButton from './components/WhatsAppButton';

const Home = () => {
  return (
    <>
      <title>Infovist</title>
      <meta name="viewport" content="width=device-width, initial-scale=1"></meta>
      <Header />
      <Banner />
      <Operation />
      <Benefits />
      <DataReceive />
      <Help />
      <Partnership />
      <Footer />
      <WhatsAppButton />
      <span></span>
    </>
  );
};

export default Home;